import React from "react";

const MinorDeclaration = () => {
  return (
    <div>
      <p class="mb-4">
        In case of Deposit is in the name of Minor then D.O.B. of Minor:
        <input
          type="text"
          class="border-b border-zinc-500 focus:outline-none focus:border-black dark:focus:border-white ml-2"
        />
      </p>
      <div class="mb-4">
        <label class="mr-2">Guardian Name:</label>
        <input
          type="text"
          class="border-b border-zinc-500 focus:outline-none focus:border-black dark:focus:border-white"
        />
        <label class="ml-4 mr-2">Type of Guardian:</label>
        <label class="mr-2">
          <input type="checkbox" class="mr-1" />
          Father
        </label>
        <label class="mr-2">
          <input type="checkbox" class="mr-1" />
          Mother
        </label>
        <label>
          <input type="checkbox" class="mr-1" />
          Court Appointed
        </label>
      </div>
      <h2 class="font-bold mb-4">Guardian Declaration</h2>
      <p class="mb-4">
        I hereby declare that the date of birth of minor which is my
        <input
          type="text"
          class="border-b border-zinc-500 focus:outline-none focus:border-black dark:focus:border-white mx-2"
        />
        is
        <input
          type="text"
          class="border-b border-zinc-500 focus:outline-none focus:border-black dark:focus:border-white mx-2"
        />
        and I am his/her natural and lawful guardian / guardian appointed by
        court order dated
        <input
          type="text"
          class="border-b border-zinc-500 focus:outline-none focus:border-black dark:focus:border-white mx-2"
        />
        (copy enclosed). I shall represent the said minor in all future
        transactions of any description in the above account until the said
        minor attains majority. I declare that the amount withdrawn from this
        account by me will be used for the benefit of the minor. I indemnify the
        company against the claim of the above minor for any withdrawal /
        transactions made by me in his / her account.
      </p>
    </div>
  );
};

export default MinorDeclaration;
